import React, { useState, useEffect, useRef, useMemo } from "react";
import { Box, DialogActions, DialogContent, Grid, Button, Typography } from "@mui/material";
import { useFiles } from "../../../../hook/useFiles";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import { Actions } from "../../../../core/modules/Actions";
import { connect } from 'react-redux';
import { COURSE_SECTION_TYPE_ID, getText } from "../../../../core/Constant";
import { useDispatch } from 'react-redux';
import VideoDropDownComponent from "../../../atom/Inputs/VideoDropDown";
import WeekDropdown from "../../../atom/Inputs/WeekDropdown";
import DocumentIcon from "../../../atom/Icons/DocumentIcon";
import SelectDocumentModal from "./SelectDocumentModal";
import SelectQuizModal from "./SelectQuizModal";
import SectionTypeIcon from "../../../atom/Icons/SectionTypeIcon";


const AdminCourseContentEditForm = ({ onClose, isclose, courseContentData, fetchVideo, uploadedVideoList, courseQuizList, getCourseQuizList, documentList, getDocumentList }) => {
    const [scroll, setScroll] = useState('paper');

    const dispatch = useDispatch();

    const filesOnly = useFiles(documentList);
    const [content_id, setContentId] = useState(0);
    const [content_type, setContentType] = useState(0);
    const [selectedDocName, setSelectedDocName] = useState("");
    const [selectedDocFolderStack, setSelectedDocFolderStack] = useState([]);
    const [openSelectModal, setOpenSelectModal] = useState(false);
    const [selectedQuizName, setSelectedQuizName] = useState("");
    const [selectedQuizFolderStack, setSelectedQuizFolderStack] = useState([]);
    const [openSelectQuizModal, setOpenSelectQuizModal] = useState(false);

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(false);
    const [titalValid, setTitleVaid] = useState(false);

    const [link, setLink] = useState('');
    const [linkError, setLinkError] = useState(false);
    const [isLinkValid, setIsLinkVaid] = useState(false);

    const [duration, setDuration] = useState('');
    const [durationError, setDurationError] = useState(false);
    const [isDurationValid, setDurationValid] = useState(false);
    const [durationErrorMsg, setDurationErrorMsg] = useState('Please add the valid duration');

    const [is_locked, setIsLocked] = useState('');
    const [lockedError, setLockedError] = useState(false);

    const [quizId, setQuizId] = useState('');
    const [quizIdError, setQuizIdError] = useState(false);
    const [quizIdValid, setQuizIdVaid] = useState(false);

    const [day, setDay] = useState('');
    const [dayError, setDayError] = useState(false);
    const [isDayValid, setDayValid] = useState(false);

    const [selectedVideoName, setSelectedVideoName] = useState('');

    const videoList = useMemo(() =>
        (Array.isArray(uploadedVideoList?.data)) ? uploadedVideoList.data : []
        , [uploadedVideoList]);





    useEffect(() => {
        setTitle("");
        setLink("");
        setDuration("");
        setDay("");
        setSelectedVideoName("");
        setSelectedDocName("");
        setSelectedDocFolderStack([]);
        setOpenSelectModal(false);
        setTitleVaid(false);
        setIsLinkVaid(false);
        setDurationValid(false);
        setLinkError(false);
        setDurationError(false);
        setTitleError(false);

        setDurationError(false);

        setSelectedQuizName("");
        setSelectedQuizFolderStack([]);
        setOpenSelectQuizModal(false);
    }, [isclose]);

    useEffect(() => {
        setTitle(courseContentData.content);
        setLink(courseContentData.content_link);
        setDuration(courseContentData.duration);
        setContentId(courseContentData.id);
        setIsLocked(courseContentData.is_locked);
        setContentType(courseContentData.content_type);

        getCourseQuizList(courseContentData.course_id);
        setQuizId(courseContentData.content_link);
        setSelectedDocName("");
        setDay(courseContentData.day);

        if (Number(courseContentData.content_type) === COURSE_SECTION_TYPE_ID.DOCUMENT) {
            setSelectedDocFolderStack(courseContentData.document_path)
            setSelectedDocName(courseContentData.document_name);
            setSelectedQuizName("");
            setSelectedQuizFolderStack([]);
            setSelectedVideoName("");
        } else if (Number(courseContentData.content_type) === COURSE_SECTION_TYPE_ID.QUIZ) {
            setSelectedQuizFolderStack(courseContentData.quiz_path)
            setSelectedQuizName(courseContentData.quiz_name || courseContentData.content);
            setSelectedDocName("");
            setSelectedDocFolderStack([]);
            setSelectedVideoName("");
        } else {
            setSelectedVideoName(courseContentData.video_name);
            setSelectedDocName("");
            setSelectedDocFolderStack([]);
            setSelectedQuizName("");
            setSelectedQuizFolderStack([]);
        }

        setTitleVaid(true);
        setTitleError(false);
        setIsLinkVaid(true);
        setLinkError(false);
        setDurationValid(true);
        setDurationError(false);
        setQuizIdVaid(true);
        setQuizIdError(false);
        setDayError(false);
        setDayValid(true);
    }, [courseContentData]);

    useEffect(() => {
        if (content_type === COURSE_SECTION_TYPE_ID.DOCUMENT && quizId && !selectedDocName && filesOnly.length > 0) {
            if (selectedDocFolderStack.length === 0) {
                const docs = Array.isArray(documentList) ? documentList : (documentList?.documents || []);
                const rawDoc = docs.find(d => String(d.id) === String(quizId));
                if (rawDoc) {
                    const parentId = rawDoc.parent_id == null || rawDoc.parent_id === 0 ? null : Number(rawDoc.parent_id);
                    if (parentId != null) {
                        const stack = [];
                        let currentId = parentId;
                        while (currentId != null && currentId !== 0) {
                            const folder = docs.find(item => Number(item.id) === Number(currentId) && Number(item.is_directory) === 1);
                            if (folder) {
                                stack.unshift({ id: folder.id, name: folder.display_name || folder.name });
                                currentId = folder.parent_id;
                            } else {
                                break;
                            }
                        }
                        setSelectedDocFolderStack(stack);
                    }
                }
            }
        }
    }, [filesOnly, quizId, content_type, selectedDocName, selectedDocFolderStack]);

    useEffect(() => {
        if (Number(content_type) === COURSE_SECTION_TYPE_ID.QUIZ && quizId && courseQuizList && courseQuizList.length > 0) {
            const quiz = courseQuizList.find(q => String(q.quiz_id) === String(quizId));
            if (quiz) {
                setSelectedQuizName(quiz.name);
            }
        }
    }, [courseQuizList, quizId, content_type]);


    const onTitleChange = (e) => {
        const text = getText(e)
        setTitle(text);
        setTitleError(false)
        const isValid = text?.length > 0;
        setTitleVaid(isValid);
    }

    const onLinkChange = (e, videoItem) => {
        const text = e?.target?.value !== undefined ? e.target.value : (typeof e === 'string' ? e : getText(e));
        setLink(text);
        setLinkError(false);
        const isValid = text?.length > 0;
        setIsLinkVaid(isValid);
        if (videoItem) {
            setSelectedVideoName(videoItem.title || videoItem.name || "");
        }
    }

    const onDurationChange = (e) => {
        const rawText = getText(e) || "";
        const cleanText = rawText.replace(/[^0-9]/g, "");
        setDuration(cleanText);
        setDurationError(false);
        const isValid = cleanText.length > 0 && Number(cleanText) > 0;
        setDurationValid(isValid);
    }

    const handleDocumentSelect = (doc, parentId, folderStack) => {
        setQuizId(doc.id);
        setSelectedDocName(doc.name);
        setSelectedDocFolderStack(folderStack);
        setQuizIdError(false);
        setQuizIdVaid(doc.id > 0);
        setOpenSelectModal(false);
    };

    const handleQuizSelect = (quiz, parentId, folderStack) => {
        setQuizId(String(quiz.id));
        setSelectedQuizName(quiz.name);
        setSelectedQuizFolderStack(folderStack);
        setQuizIdError(false);
        setQuizIdVaid(true);
        setTitle(quiz.name || "");
        setTitleVaid((quiz.name || "").length > 0);
        setTitleError(false);
        if (quiz.duration) {
            const quizDuration = String(quiz.duration);
            setDuration(quizDuration);
            setDurationValid(Number(quizDuration) > 0);
            setDurationError(false);
        }
        setOpenSelectQuizModal(false);
    };

    const onDayChange = (e) => {
        const text = getText(e)
        setDay(text);
        setDayError(false)
        const isValid = text >= 0;
        setDayValid(isValid);
    }

    const onKeyChangeDuration = (e) => {
        const rawText = getText(e) || "";
        const cleanText = rawText.replace(/[^0-9]/g, "");
        setDuration(cleanText);
        setDurationError(false);
        const isValid = cleanText.length > 0 && Number(cleanText) > 0;
        setDurationValid(isValid);
    }

    const updateCourseContent = () => {

        if (titalValid && isDurationValid && ((content_type === COURSE_SECTION_TYPE_ID.VIDEO && isLinkValid && isDayValid) || (content_type === COURSE_SECTION_TYPE_ID.QUIZ && quizIdValid) || (content_type === COURSE_SECTION_TYPE_ID.DOCUMENT && quizIdValid))) {
            const content_data = content_type === COURSE_SECTION_TYPE_ID.VIDEO ? link : quizId;
            const payload = [{
                id: String(content_id),
                content_type: Number(content_type),
                content: title,
                link: content_data,
                duration,
                is_locked,
                day,
            }];

            dispatch(Actions.course.updateCourseContent(payload));
            onClose();
        } else {

            if (!titalValid) {
                setTitleError(true);
            }

            if (!isDurationValid) {
                setDurationError(true);
            }

            if (content_type === COURSE_SECTION_TYPE_ID.VIDEO) {
                if (!isLinkValid) {
                    setLinkError(true);
                }
            } else {
                if (!quizIdValid) {
                    setQuizIdError(true);
                }
            }


        }
    }

    return (
        <>
            <form>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} md={9}>
                            <Box>
                                <TextInputComponent
                                    label={"Title"}
                                    isError={titleError}
                                    placeholder="Enter title"
                                    name={"title"}
                                    value={title}
                                    error={"Please add the title"}
                                    onchange={onTitleChange}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Box>
                                <WeekDropdown
                                    selectedValue={day}
                                    onchange={onDayChange}
                                    isError={dayError}
                                    error="Please select a day"
                                    readOnly={false}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <Box>
                                <Box>
                                    {content_type === COURSE_SECTION_TYPE_ID.VIDEO ? (<>
                                        <VideoDropDownComponent
                                            placeholder="Please add the link"
                                            onchange={onLinkChange}
                                            list={videoList}
                                            selectedValue={link ? {
                                                link: link,
                                                id: link,
                                                name: selectedVideoName || courseContentData?.video_name || courseContentData?.content || "",
                                                title: selectedVideoName || courseContentData?.video_name || courseContentData?.content || "",
                                            } : ""}
                                            initialValue={""}
                                            dropdownLabel="Video Link" />
                                        {linkError ? <p className="input-error-text">Select video link</p> : null}
                                    </>) : content_type === COURSE_SECTION_TYPE_ID.QUIZ ? (<>
                                        <Box style={{ padding: 10 }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "100%",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        marginBottom: 10,
                                                        color: "#4E657C",
                                                        fontSize: 19,
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    Quiz
                                                </p>
                                                <Box
                                                    onClick={() => setOpenSelectQuizModal(true)}
                                                    className="form-control"
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        cursor: "pointer",
                                                        borderColor: quizIdError ? "#d32f2f" : undefined,
                                                    }}
                                                >
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflow: "hidden" }}>
                                                        {quizId ? (
                                                            <>
                                                                <SectionTypeIcon contentType={2} />
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "14px",
                                                                        color: "#495057",
                                                                        fontWeight: 400,
                                                                        fontFamily: "Montserrat",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        direction: "rtl",
                                                                        textAlign: "left",
                                                                        mr: 1
                                                                    }}
                                                                >
                                                                    {selectedQuizName}
                                                                </Typography>
                                                            </>
                                                        ) : (
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    color: "#8C8C8C",
                                                                    fontFamily: "Montserrat",
                                                                }}
                                                            >
                                                                Select Quiz
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Button
                                                        variant="text"
                                                        sx={{
                                                            textTransform: "none",
                                                            color: "#9834F0",
                                                            fontWeight: 600,
                                                            fontFamily: "Montserrat",
                                                            padding: 0,
                                                            minWidth: "auto",
                                                            fontSize: "14px",
                                                            "&:hover": { backgroundColor: "transparent" },
                                                        }}
                                                    >
                                                        {quizId ? "Change" : "Browse"}
                                                    </Button>
                                                </Box>
                                                {quizIdError && (
                                                    <Typography
                                                        sx={{
                                                            color: "#d32f2f",
                                                            fontSize: "12px",
                                                            fontFamily: "Montserrat",
                                                            marginLeft: "14px",
                                                            marginTop: "4px",
                                                        }}
                                                    >
                                                        Please select a quiz
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </>) : content_type === COURSE_SECTION_TYPE_ID.DOCUMENT ? (<>
                                        <Box style={{ padding: 10 }}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "100%",
                                                }}
                                            >
                                                <p
                                                    style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        marginBottom: 10,
                                                        color: "#4E657C",
                                                        fontSize: 19,
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    Document
                                                </p>
                                                <Box
                                                    onClick={() => setOpenSelectModal(true)}
                                                    className="form-control"
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        cursor: "pointer",
                                                        borderColor: quizIdError ? "#d32f2f" : undefined,
                                                    }}
                                                >
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflow: "hidden" }}>
                                                        {quizId ? (
                                                            <>
                                                                <DocumentIcon fileName={selectedDocName} />
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "14px",
                                                                        color: "#495057",
                                                                        fontWeight: 400,
                                                                        fontFamily: "Montserrat",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        whiteSpace: "nowrap",
                                                                        direction: "rtl",
                                                                        textAlign: "left",
                                                                        mr: 1
                                                                    }}
                                                                >
                                                                    {selectedDocName}
                                                                </Typography>
                                                            </>
                                                        ) : (
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    color: "#8C8C8C",
                                                                    fontFamily: "Montserrat",
                                                                }}
                                                            >
                                                                Select Document
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                    <Button
                                                        variant="text"
                                                        sx={{
                                                            textTransform: "none",
                                                            color: "#9834F0",
                                                            fontWeight: 600,
                                                            fontFamily: "Montserrat",
                                                            padding: 0,
                                                            minWidth: "auto",
                                                            fontSize: "14px",
                                                            "&:hover": { backgroundColor: "transparent" },
                                                        }}
                                                    >
                                                        {quizId ? "Change" : "Browse"}
                                                    </Button>
                                                </Box>
                                                {quizIdError && (
                                                    <Typography
                                                        sx={{
                                                            color: "#d32f2f",
                                                            fontSize: "12px",
                                                            fontFamily: "Montserrat",
                                                            marginLeft: "14px",
                                                            marginTop: "4px",
                                                        }}
                                                    >
                                                        Please select a document
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </>) : null}

                                </Box>
                            </Box>
                        </Grid>
                        {
                            content_type !== COURSE_SECTION_TYPE_ID.DOCUMENT &&
                            <Grid item xs={12} md={6}>
                                <Box>
                                    <TextInputComponent
                                        label={"Duration (MIN)"}
                                        isError={durationError}
                                        placeholder="Duration (MIN)"
                                        name={"duration"}
                                        value={duration}
                                        error={durationErrorMsg}
                                        type="text"
                                        onchange={onDurationChange}
                                        keyup={onKeyChangeDuration}
                                    />

                                </Box>
                            </Grid>
                        }

                        <Grid item xs={12} md={6}>
                            <Box>
                                <Box style={{ padding: 10 }}>
                                    <p className="form-label">Lock Status</p>
                                    <select className="form-control" value={is_locked} name="is_locked" id="is_locked" onChange={(e) => setIsLocked(e.target.value)}>
                                        <option value={1}>Locked</option>
                                        <option value={0}>Un-Lock</option>
                                    </select>
                                    {lockedError ? <p className="input-error-text">Please select</p> : null}

                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextButtonComponet text={"Update"} width={120} onButtonClick={() => updateCourseContent()} />
                        <TextButtonComponet text={"Close"} classStyle="btn btn-secondary" width={120} onButtonClick={() => onClose()} />
                    </Box>

                </DialogActions>
            </form>
            <SelectDocumentModal
                open={openSelectModal}
                onClose={() => setOpenSelectModal(false)}
                courseID={courseContentData?.course_id}
                onSelect={handleDocumentSelect}
                initialFolderStack={selectedDocFolderStack}
                selectedDocId={quizId}
            />
            <SelectQuizModal
                open={openSelectQuizModal}
                onClose={() => setOpenSelectQuizModal(false)}
                courseID={courseContentData?.course_id}
                onSelect={handleQuizSelect}
                initialFolderStack={selectedQuizFolderStack}
                selectedQuizId={quizId}
            />
        </>
    );
}

export default connect(
    state => ({
        uploadedVideoList: state.video.get("uploadedVideoList"),
        loadingAction: state.common.get("loadingAction"),
        courseQuizList: state.course.get("courseQuizList"),
        documentList: state.course.get("courseDocumentList"),
    }), {
    fetchVideo: Actions.video.fetchVideo,
    getCourseQuizList: Actions.course.getCourseQuizList,
    getDocumentList: Actions.course.getCourseDocumentList,
},
)(AdminCourseContentEditForm);

